import type { CustomErrorRule } from '@/core/error/transport/types'
import { EndpointsEnum } from '@/services/endpoints'
import { TmAuthNeedVerifyEmailError } from '@/core/error/transport/auth/TmAuthNeedVerifyEmailError'

export const needVerifyEmailErrorRule: CustomErrorRule = {
  endpoint: EndpointsEnum.login,
  subCodes: ['auth.email_not_verified'],
  klass: TmAuthNeedVerifyEmailError,
}
